<template>
  <FaIcon :icon="['fas', PERMISSION_DEFAULT_ICON]" />
</template>

<script setup lang="ts">
import { PERMISSION_DEFAULT_ICON } from '@/constants/permission';
</script>
